export default __webpack_public_path__ + "static/media/new-fund-side-img.4ccbbb50.svg";